<template>
    <div class="m-portlet">
        <div class="card-header">
            <h5>流失情况</h5>
        </div>
        <div class="m-portlet__body">
            <div class="card-header">
                <el-row>
                    <el-select v-model="semester" placeholder="请选择学期" @change="changeSemester(semester)">
                        <el-option
                                v-for="item in semesters"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-row>
            </div>
            <div class="m-portlet__body">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <ve-pie :data="organizationLossRate"></ve-pie>
                    </el-col>
                    <el-col :span="18">
                        <el-row>【班主任名下学生流失——续班情况】</el-row>
                        <el-row>
                            <el-col :span="8" v-for="headStudent in headStudents">
                                <div class="m-portlet" style="width: 300px">
                                    <div class="card-header">
                                        {{headStudent.name}}
                                        <i class="el-icon-caret-right" style="margin-left: 200px"></i>
                                    </div>
                                    <div class="m-portlet__body">
                                        <el-row>
                                            <el-col :span="12"> 流失率： {{headStudent.headTeacherLossRate}}</el-col>
                                            <el-col :span="12"> 续班率： {{headStudent.headTeacherRetentionRate}}</el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">流失学生： {{headStudent.nowNumber1}}人</el-col>
                                            <el-col :span="12">续班学生： {{headStudent.resultNumber1}}人</el-col>
                                        </el-row>
                                    </div>

                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div class="m-portlet">
                <div class="card-header">
                    <el-row>
                        <el-col :span="6"> 【老师名下学生流失——续班情况表】</el-col>
                        <!--<el-col :span="6">筛选老师：-->
                        <!--<el-select v-model="teacher" clearable  placeholder="请选择老师" filterable remote :remote-method="handleSearchTeacher" @change="changeTeachers()">-->
                        <!--<el-option-->
                        <!--v-for="item in teachers"-->
                        <!--:key="item.id"-->
                        <!--:label="item.name"-->
                        <!--:value="item.id">-->
                        <!--</el-option>-->
                        <!--</el-select>-->
                        <!--</el-col>-->
                    </el-row>
                </div>
                <div class="m-portlet__body">
                    <table class="table" v-loading="loading">
                        <thead>
                        <tr>
                            <th>教师</th>
                            <th>流失学生</th>
                            <th>流失率</th>
                            <th>续班学生</th>
                            <th>续班率</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="teacherStudent in teacherStudents">
                            <td>{{teacherStudent.name}}</td>
                            <td>{{teacherStudent.lossStudent}}人</td>
                            <td>{{teacherStudent.teacherLossRate}}</td>
                            <td>{{teacherStudent.retentionStudent}}人</td>
                            <td>{{teacherStudent.teacherRetentionRate}}</td>
                            <td>
                                <el-button type="text" size="small">查看详情</el-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'

    export default {
        name: "organizationLoss-rate",
        data() {
            this.chartSettings = {
                dimension: '比例',
                metrics: '访问用户'
            }
            return {
                semesters: [],
                nowSemester: [],
                teachers: [],
                teacher: '',
                loading: 'true',
                semester: '',
                sameNumber: '',
                lossNumber: '',
                chooseSemester: '',
                students: [],
                headStudents: [],
                teacherStudents: [],
                organizationLossRate: {
                    columns: ['比例', '人数'],
                    rows: [
                        {'比例': '续班率', '人数': null},
                        {'比例': '流失率', '人数': null},
                    ]
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.loading = false
            })
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            }
        },
        created() {
            this.nowSemester = JSON.parse(localStorage.nowSemester);
            this.handleOrganizationIndex();
            this.handleHeadTeacherIndex();
            this.handleTeacherIndex();
            this.handleCreate();
            // this.handleSearchTeacher("");
        },
        methods: {
            handleCreate() {
                this.$axios.get(store.state.server + '/student/list/create' + '?' + localStorage.baseUrl).then(response => {
                    if (response.data.status == 'success') {
                        this.semesters = response.data.data.semesters;
                        this.semester = this.nowSemester.id;
                    }
                })
            },
            // handleSearchTeacher(query) {
            //     this.$axios.get(store.state.server + '/report/teacherLossRate/search?teacherKeyName=' + query + '&' + localStorage.baseUrl).then((response) => {
            //         if (response.data.status == 'success') {
            //             this.teachers = response.data.data.teachers;
            //         }
            //     })
            // },
            // changeTeachers(){
            //     const teacher =this.teacher;
            //     this.handleTeacherIndex(teacher);
            // },
            changeSemester() {
                const semester = this.semester;
                this.handleOrganizationIndex(semester);
                this.handleHeadTeacherIndex(semester);
                this.handleTeacherIndex(semester);
            },
            handleOrganizationIndex() {
                this.$axios.get(store.state.server + '/report/organizationLossRate?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id).then(response => {
                    if (response.data.status == 'success') {
                        this.sameNumber = response.data.data.sameNumber;
                        this.lossNumber = response.data.data.lossNumber;
                        this.students = response.data.data.students;
                        this.chooseSemester = response.data.data.chooseSemester;
                        this.organizationLossRate.rows[0]['人数'] = this.sameNumber;
                        this.organizationLossRate.rows[1]['人数'] = this.lossNumber;
                    }
                })
            },
            handleHeadTeacherIndex() {
                this.$axios.get(store.state.server + '/report/headTeacherLossRate?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id).then(response => {
                    if (response.data.status == 'success') {
                        this.headStudents = response.data.data.headStudents;
                    }
                })
            },
            handleTeacherIndex() {
                this.$axios.get(store.state.server + '/report/teacherLossRate?' + '&semester=' + this.semester + '&' + localStorage.baseUrl + '&nowSemester=' + this.nowSemester.id + '&teacher=' + this.teacher).then(response => {
                    if (response.data.status == 'success') {
                        this.teacherStudents = response.data.data.teacherStudents;
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
